import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Notificacion } from '../../models/notificacion.model';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class NotificacionReferidoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.NOTIFICACION_REFERIDO}`;

  constructor(private http: HttpClient) {}

  guardar(notificacion: Notificacion): Observable<any> {
    return this.http.post(`${this.apiUrl}/guardar`, notificacion);
  }

  crearNoticacionComisionesSiAplica(asesorId: number, fechaNotificacion: Date) {
    const body = { 
      asesorId,
      fechaNotificacion
     };
    return this.http.post<void>(`${this.apiUrl}/crear-comisiones-asesor-si-aplica`, body);
  }

  getActiveNotifications(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/todas`);
  }

  actualizarEstado(idNotificacion: number, estado: boolean): Observable<any> {
    const url = `${this.apiUrl}/${idNotificacion}/estado`;
    const body = { estado: estado };
    return this.http.patch(url, body);
  }

  obtenerPorAsesor(asesorId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/asesor/${asesorId}`);
  }

  crearNotificacionSiAplica(asesorId: number, usuarios: number[]) {
    const body = {
      asesorId,
      usuarios, // ahora es un array de IDs
    };

    return this.http.post<void>(`${this.apiUrl}/crear-si-aplica`, body);
  }

  crearNotificacionMomentosWow(asesorId: number) {
    return this.http.post<void>(
      `${this.apiUrl}/crear-notificacion-momentos-wow`,
      { asesorId },
    );
  }
}
